import { render, staticRenderFns } from "./shareButton.vue?vue&type=template&id=5b4b6710&scoped=true&"
import script from "./shareButton.vue?vue&type=script&lang=js&"
export * from "./shareButton.vue?vue&type=script&lang=js&"
import style0 from "./shareButton.vue?vue&type=style&index=0&id=5b4b6710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b6710",
  null
  
)

export default component.exports